import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import Header from '@/components/Header'
import HeroBackdrop from '@/components/landing/HeroBackdrop'
import { isHeroPath } from '@/data/heroBackground'
import { usePublicPaths } from '@/hooks/usePublicPaths'

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const isPublicPath = usePublicPaths()
  const isGoodbyePage = location.pathname === '/goodbye'

  const isHero = isHeroPath(location.pathname)
  const isCurrentPathPublic = useMemo(
    () => isPublicPath(location.pathname) || isGoodbyePage,
    [location.pathname, isPublicPath, isGoodbyePage],
  )

  return (
    <div className="flex min-h-dvh flex-col">
      {isHero ? <HeroBackdrop /> : null}
      <Header />
      <main
        className={
          isHero || !isCurrentPathPublic
            ? 'flex flex-1 flex-col'
            : 'flex flex-1 flex-col pt-16'
        }
      >
        {children}
      </main>
    </div>
  )
}

export default AuthLayout
